import { load } from "./events/load.js";
import { intersect } from "./events/intersect.js";
load(() => {
  let files = document.querySelectorAll("#documents .item .hidden-data");

  files.forEach((file) => {
    const data = JSON.parse(file.textContent);
    const parent = file.closest(".item");
    const format = data.url.split(".").at(-1);
    const url = data.url;
    const date = data.date.split(" ")[0].split("-").reverse().join(".");
    let size = data.filesize;
    const dict = ["B", "KB", "MB", "GB", "TB"];
    for (let i = 0; i < dict.length; i++) {
      if (size > 1024) {
        size = size / 1024;
      } else {
        size = size.toFixed(1) + dict[i];
        break;
      }
    }

    parent.querySelector(".item__format").textContent = format + ", " + size;
    parent.querySelector(".item__date").textContent = date;

    parent.querySelector(".item__icon").addEventListener("click", () => {
      const a = document.createElement("a");
      a.href = url;
      a.download = ""; 
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  });
});

intersect("#documents .item", (entry) => {
	if(window.innerWidth < 992) return;
	if(entry.isIntersecting){
		document.querySelectorAll(`#documents .aside p.active`).forEach((el) => el.classList.remove("active"))
		document.querySelector(`#documents .aside p[data-index="${entry.target.dataset.index}"]`).classList.add("active")
	}
}, false, {rootMargin: '-30% 0px -70% 0px',threshold: [0,1]});